import React from "react";
import { useHistory } from "react-router-dom";
import "./Login.css";

function MaintenancePage() {
  const history = useHistory();
  return (
    <div className="containerLogin">
      <div className="maintenance-container">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="80"
          height="80"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"></path>
        </svg>
        <h1>La solution digitale des Éditions Langloÿs est en maintenance</h1>
        <p>
          Nous effectuons actuellement une mise à jour. <br />
          Le site sera de retour très prochainement. Merci de votre patience.
        </p>
        <button
          className="maintenance-button"
          onClick={() => history.push("/login")}
        >
          Réessayer
        </button>
      </div>
    </div>
  );
}

export default MaintenancePage;